import { Component, OnInit } from '@angular/core';
import { CatRoles } from '../../entidades/entidades';
import { MuestraMensaje } from "../../shared/utilerias/notificaciones/notificaciones.component";
import { Observable } from 'rxjs';
import { MenuItem } from "primeng/api";


declare var $: any;

@Component({
  selector: 'app-permisos',
  templateUrl: './permisos.component.html',
  styleUrls: ['./permisos.component.css']
})
export class PermisosComponent implements OnInit {
  public id$: Observable<number>;
  message: string;
  errorMessage: any;
  catroles: CatRoles[] = [];
  catrol: CatRoles = new CatRoles();
  public menu: MenuItem[];
  public menuSelected: MenuItem = { label: "Roles" };

  constructor(muestraMensaje: MuestraMensaje) {
    this.message = "Catalogo de Roles";
  }

  muestraMensaje: MuestraMensaje = new MuestraMensaje();

  ngOnInit() {
    this.menu = [
      {
        label: "Seguridad",
        icon: "fa fa-user-secret",
        items: [
          {
            label: "Catálogo Usuarios",
            icon: "fa fa-user-circle",
            command: (event) => {
              this.menuSelected = event.item;
            },
          },
          {
            label: "Catálogo Roles",
            icon: "fa fa-cog",
            command: (event) => {
              this.menuSelected = event.item;
            },
          },
          // {
          //   label: "Catálogo Modulos",
          //   icon: "fa fa-puzzle-piece",
          //   command: (event) => {
          //     this.menuSelected = event.item;
          //   },
          // },
          {
            label: "Catálogo Privilegios",
            icon: "fa fa-star",
            command: (event) => {
              this.menuSelected = event.item;
            },
          },
          {
            label: "Catálogo Nivel Seguridades",
            icon: "fa fa-low-vision",
            command: (event) => {
              this.menuSelected = event.item;
            },
          },
          {
            label: "Privilegios a Roles",
            icon: "fa fa-cogs",
            command: (event) => {
              this.menuSelected = event.item;
            },
          },
          {
            label: "Niveles de Seguridad",
            icon: "fa fa-eye",
            command: (event) => {
              this.menuSelected = event.item;
            },
          },
          {
            label: "Roles a Usuarios",
            icon: "fa fa-universal-access",
            command: (event) => {
              this.menuSelected = event.item;
            },
          },
          {
            label: "Catálogo Direccion",
            icon: "pi pi-compass",
            command: (event) => {
              this.menuSelected = event.item;
            },
          },
          {
            label: "Catálogo Departamento",
            icon: "pi pi-table",
            command: (event) => {
              this.menuSelected = event.item;
            },
          },
          {
            label: "Catálogo Cargo",
            icon: "pi pi-plus",
            command: (event) => {
              this.menuSelected = event.item;
            },
          },
       

        ],
      },
    ];
  }

}
